import React from 'react'

import { useParams } from 'react-router'

import { HeaderView } from 'components/page/ForeignProfile/Header/HeaderView'
import { ProfileRouteParams } from 'components/paths'

export const Header = () => {
  const { userId } = useParams<ProfileRouteParams>()

  if (userId) {
    return <HeaderView userId={Number(userId)} />
  }

  return null
}
